/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

//获取城市列表
const getCityList = (state) => {
  return state.appCommon.cityList
}

//获取城市列表的值
const getCityListValue = (state) => {
  return state.appCommon.cityListValue
}

//获取话题列表
const getTopicList = (state) => {
  return state.appCommon.topicList
}

//获取品牌列表
const getBrandList = (state) => {
  return state.appCommon.brandList
}

//获取资讯详情中缓存的图片
const getBannerImgs = (state) => {
	return state.appCommon.topicInfoImgs
}

module.exports = {
  getCityList,
  getTopicList,
  getBrandList,
  getCityListValue,
  getBannerImgs
}



// WEBPACK FOOTER //
// ./src/appBackend/vuex/getter/common.js